import {
  Component, DestroyRef,
  EventEmitter, inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Outlet } from '../../app-shared/models/supplier-outlet.model';
import { SupplierOutletService } from '../../app-shared/services/supplier-outlet.service';
import { ActivateCodeFormComponent } from '../../app-shared/components/activate-code-form/activate-code-form.component';
import { SettingsService } from '../../app-shared/services/settings.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-select-outlet-activation',
    templateUrl: './select-outlet-activation.component.html',
    styleUrls: ['./select-outlet-activation.component.scss'],
    standalone: false
})
export class SelectOutletActivationComponent {
  @ViewChild(ActivateCodeFormComponent) form: ActivateCodeFormComponent;
  outlet: Outlet;
  mobile: boolean;
  loading: boolean;
  @Output() goNext = new EventEmitter();
  @Output() goPrev = new EventEmitter();
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private supplierOutletService: SupplierOutletService,
    private settings: SettingsService,
    private router: Router,
    private location: Location
  ) {
    this.outlet =
      this.supplierOutletService.getSelectOutletForActivateCatalog();
    this.mobile = this.settings.isMobileSize();
  }

  goPrevClick() {
    this.goPrev.emit();
    if (this.mobile) {
      this.location.back();
    }
  }

  sendActivationCode() {
    this.loading = true;
    this.supplierOutletService
      .getOutletByActivationCode({
        outletId: this.outlet.outletId,
        activationCode:
          this.form.formActivateCatalog.get('activationCode').value,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.goNext.emit();
          if (this.mobile) {
            this.router.navigate(['/addcategory/activate-outlet-result']);
          }
        },
        error: (error) => {
          this.loading = false;
          this.form.validateOnSubmit(error);
        },
      });
  }
}
